//@ts-check
import {CustomDataTable} from '@/components/organisms'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useComboProductTable} from '@/hooks/productCombo/useComboProductTable'
import {DEFAULT_TABLE_PAGE_SIZE} from '@/utils/constants/commonConstants'
import {comboProductTableColumns} from '@/utils/productCombo/productComboConstants'
import {Font} from 'pepsico-ds'
import {useEffect, useRef} from 'react'

export const ComboProductTable = ({selectedCategories}) => {
  const {
    data,
    setSortingObj,
    setSearchArry,
    onPageIndexChange,
    isLoading,
    handleResetAll,
    onRowSelection,
    isSelectAll,
    handleIsSelectAll,
  } = useComboProductTable()
  const {
    productCombo: {comboSkus, productLimit},
  } = useProductCombo()
  const tableRef = useRef(null)

  useEffect(() => {
    if (selectedCategories?.length === 0) {
      tableRef?.current?.resetAll()
    }
  }, [selectedCategories, handleResetAll])

  return (
    <div className="flex flex-col gap-6 rounded-lg bg-gray-850 p-6">
      <Font variant="bold">Product Table</Font>
      <CustomDataTable
        columns={comboProductTableColumns}
        records={data?.data || []}
        setSearchArry={setSearchArry}
        handleSorting={setSortingObj}
        setPageIndex={onPageIndexChange}
        totalRecords={data?.totalRecords || 0}
        pageSize={DEFAULT_TABLE_PAGE_SIZE}
        onResetAll={handleResetAll}
        onRowSelect={onRowSelection}
        isLoading={isLoading}
        showActions={false}
        id="productId"
        initialSelectedRows={comboSkus ?? []}
        showResetAll={true}
        isSelectAll={isSelectAll}
        setSelectAll={handleIsSelectAll}
        defaultSortConfig={{key: 'productId', direction: 'desc'}}
        selectionError={
          typeof productLimit === 'number' && comboSkus && comboSkus.length > productLimit
            ? `Selection limit reached. You can select a maximum of ${productLimit} records based on the Product Limit value.`
            : undefined
        }
        ref={tableRef}
      />
    </div>
  )
}
